import { parse } from '../dom';
// import { closeMenu } from './menu';

// TODO clean this up, boooiii

const searchCache = new Map();

export const search = () => {
  const searchToggle = document.querySelector('.search-toggle');
  const searchContainer = document.querySelector('.search-container');
  const searchForm = document.querySelector('.search-form');
  const searchInput = document.querySelector('.search-input');
  const searchClose = document.querySelector('.search-close');
  const searchResults = document.querySelector('.search-body');

  searchToggle?.addEventListener('click', function () {
    if (!searchContainer.classList.contains('is-active')) {
      openSearch();
    } else {
      closeSearch();
    }
  });

  searchClose?.addEventListener('click', (e) => {
    e.preventDefault();
    closeSearch();
  });

  // search results
  searchForm?.addEventListener('submit', fetchResults);

  let searchTimeout = null;

  searchInput?.addEventListener('keyup', async (e) => {
    if (e.key === 'Escape') {
      searchTimeout && clearTimeout(searchTimeout);
      return;
    }

    // if results are in cache
    if (searchCache.has(searchInput.value)) {
      // get results from cache
      const results = searchCache.get(searchInput.value);
      searchResults.innerHTML = results;
    } else {
      // debounce keyup search results
      if (searchInput.value.length > 2) {
        searchTimeout && clearTimeout(searchTimeout);
        searchResults.innerHTML = '';
        // fetch results
        searchTimeout = setTimeout(fetchResults, 500);
      }
    }
  });

  async function fetchResults(e) {
    e?.preventDefault();
    const term = searchInput.value;

    try {
      const html = await fetch(`${window.location.origin}/?s=${term}`).then(
        (rez) => rez.text(),
      );
      const fakeDom = parse(html);
      let results = fakeDom.querySelector('#search-results-list')?.innerHTML;
      if (!results || results === '') {
        results =
          '<div class="search-result-item" style="border-bottom: 0;">No Results</div>';
      }

      // cache results
      searchCache.set(term, results);
      searchResults.innerHTML = results;

      let nextPageLink = fakeDom.querySelector(
        '#search-navigation .nav-previous a',
      )?.href;

      if (nextPageLink) addMoreButton(nextPageLink);
    } catch (e) {
      console.log(e);
    }
  }
};

const addMoreButton = (href) => {
  let url = new URL(href);
  url = `${window.location.origin}${url.pathname}${url.search}`;

  const searchResults = document.querySelector('.search-body');
  const pagination = document.querySelector('.search-footer');

  // load more results
  const handleClick = async (e) => {
    e.preventDefault();

    try {
      const html = await fetch(url).then((rez) => rez.text());
      const fakeDom = parse(html);
      const results = fakeDom.querySelector('#search-results-list')?.innerHTML;

      searchResults.innerHTML += results;
      moreButton.remove();

      let nextPageLink = fakeDom.querySelector(
        '#search-navigation .nav-previous a',
      )?.href;

      if (nextPageLink) addMoreButton(nextPageLink);
    } catch (e) {
      console.log(e);
    }
  };

  const moreButton = (
    <a
      href={href}
      class="search-more wp-block-button__link"
      onClick={handleClick}
    >
      Load More
    </a>
  );

  pagination.innerHTML = '';
  pagination.appendChild(moreButton);
};

const openSearch = async () => {
  const searchContainer = document.querySelector('.search-container');
  const searchInput = document.querySelector('.search-input');

  // close mobile menu if open
  // closeMenu();

  document.body.classList.add('search-open');
  searchContainer?.classList.toggle('is-active');

  await searchContainer?.animate([{ opacity: 0 }, { opacity: 1 }], {
    duration: 200,
  }).finished;

  searchInput?.focus();
};

export const closeSearch = async () => {
  const searchContainer = document.querySelector('.search-container');
  const searchResults = document.querySelector('.search-body');
  const searchInput = document.querySelector('.search-input');
  const pagination = document.querySelector('.search-footer');

  document.body.classList.remove('search-open');

  await searchContainer?.animate([{ opacity: 1 }, { opacity: 0 }], {
    duration: 200,
  }).finished;

  searchContainer?.classList.remove('is-active');
  searchResults && (searchResults.innerHTML = '');
  searchInput && (searchInput.value = '');
  pagination && (pagination.innerHTML = '');
};
